export default __webpack_public_path__ + "empty-search.fd170bfa.png";